import { useRecoilState } from "recoil";
import SitePromotionUI from "./PromotionWrapsodyAndEco.presenter";
import { useEffect, useState } from "react";
import { navStepAtom, userInfoAtom } from "src/atoms";
import moment from "moment";
import { getProductInfo } from "src/utils/storage/product";
import { useRouter } from "src/hooks/useRouter";
import { notifyError } from "src/components/Common/Toast";
import { ICreateServiceBillReq } from "src/service/types/pay.type";
import { createServiceBill, createServicePremiumBill } from "src/service/pay";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";

const WrapsodyAndEcoSitePromotion = () => {
  const [userInfo, setUserInfo] = useRecoilState(userInfoAtom);
  const [promotionCode, setPromotionCode] = useState<string>("");
  const [navStep, setNavStep] = useRecoilState(navStepAtom);
  const [isCheckPromotionCode, setIsCheckPromotionCode] =
    useState<string>("NONE");
  const [startDate, setStartDate] = useState(moment().format("YYYY-MM-DD"));
  const [endDate, setEndDate] = useState(
    moment(Date.now() + 365 * 24 * 3600 * 1000).format("YYYY-MM-DD")
  );
  const [isRenew, setIsRenew] = useState(false);
  const [serviceBillUid, setServiceBillUid] = useState("");
  // const [referralId, setReferralId] = useState("");
  const { t } = useTranslation();
  // 추후 쓸일있을지 검토
  const [isApplyDone, setIsApplyDone] = useState(false);
  // 요새 안쓰는 UI (프로모션 코드가 적용되었습니다.)
  const [isCreateDone, setIsCreateDone] = useState(false);
  const [isHasSite, setIsHasSite] = useState(true);
  const productName = getProductInfo().name;
  const [toggleAskPromotionOn, setToggleAskPromotionOn] = useState(false);
  const route = useRouter();

  // const { getMySiteStatus } = useGetMySiteStatus();
  useEffect(() => {
    async function init() {
      setNavStep(2); // 구독 결제정보 입력
      // await this.commonStore.getMySiteStatus()
      // await getMySiteStatus({});
      window.sessionStorage.removeItem("payType");
      // if (!this.commonStore.confirmPromotion) {
      //   window.location.href = `${process.env.PUBLIC_URL}/${lang}/site/type`
      // }
      // isRenewService({ route });
    }
    init();
  }, []);

  // 프로모션 코드 적용 (Wrapsody, eCo)
  const promotionApply = async ({
    issueAppList,
    referralId,
  }: {
    issueAppList: string[];
    referralId: string;
  }) => {
    if (isCheckPromotionCode !== "OK") {
      notifyError(t("siteType.premium.detail.plan.invalidPromotionCode"));
      return;
    }
    // if (
    //   //this.state.priceType === 'promotion' &&
    //   this.state.nxacAppUids.length < 4
    // ) {
    //   alert(t('cashStatus.chooseAppFour'))
    //   return
    // }

    // 고정 요청값
    const defaultRequest: ICreateServiceBillReq = {
      userCode: userInfo.userCode,
      billType: "PROMOTION",
      billCode: promotionCode,
      serviceId: "",
      region: "",
      product: "",
      serviceName: "",
      referralId,
      nxacAppUids: issueAppList ?? [],
    };
    let serviceRequest: ICreateServiceBillReq = {};
    if (promotionCode !== "" && !isRenew) {
      serviceRequest = {
        ...defaultRequest,
        serviceBillUid: "",
        currency: "WON",
        payCompany: "CASH",
      };
    } else if (promotionCode !== "" && isRenew) {
      serviceRequest = {
        ...defaultRequest,
        serviceBillUid: serviceBillUid,
      };
    }

    // console.log("createServiceBill", serviceRequest);
    // await createServiceBill({
    //   ...serviceRequest,
    // })
    await createServicePremiumBill({
      promotionCode,
    })
      .then((result) => {
        // console.log("createServicePremiumBill", result);
        route.goConsole();
      })
      .catch((error: any) => {
        if (error.errorCode && error.errorMessage) {
          alert(error.errorMessage);
        }
      });
  };

  const goPromiton = () => {
    route.goSitePromotion({});
  };

  const goBack = () => {
    route.goConsole();
  };

  // isCreateDone일때 버튼 onClick
  const goNext = () => {
    // setShowSiteNewModal(true);
  };
  const methods = useForm();
  return (
    // <></>
    <SitePromotionUI
      promotionCode={promotionCode}
      setPromotionCode={setPromotionCode}
      startDate={startDate}
      endDate={endDate}
      setStartDate={setStartDate}
      setEndDate={setEndDate}
      isCheckPromotionCode={isCheckPromotionCode}
      setIsCheckPromotionCode={setIsCheckPromotionCode}
      isRenew={isRenew}
      promotionApply={promotionApply}
      isApplyDone={isApplyDone}
      isCreateDone={isCreateDone}
      isHasSite={isHasSite}
      goBack={goBack}
      goNext={goNext}
      goPromiton={goPromiton}
      productName={productName}
      toggleAskPromotionOn={toggleAskPromotionOn}
      setToggleAskPromotionOn={setToggleAskPromotionOn}
    />
  );
};
export default WrapsodyAndEcoSitePromotion;
